import { render, staticRenderFns } from "./cursos-opciones.vue?vue&type=template&id=4171c8fd&scoped=true&"
import script from "./cursos-opciones.vue?vue&type=script&lang=ts&"
export * from "./cursos-opciones.vue?vue&type=script&lang=ts&"
import style0 from "./cursos-opciones.vue?vue&type=style&index=0&id=4171c8fd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171c8fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VDataTable})
